import { IVisaVerificationState } from "@/core/interfaces/visaVerificationState.interface";

const visaVerificationModule: IVisaVerificationState = {
  isAddingRequestLoading: false,
  isFetchingRequestLoading: false,
  isDownloadVisaLoading: false,
  visaRequestsList: null,
};

export default visaVerificationModule;
